import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {PrintDataContent} from "../../../../components/GenericComponent/PrintDataContent";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
export const BtnInDanhSach = () => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );
  const cookies = new Cookies();
  let link = configs.endPoint;
  var apilink = cookies.get("apilink");
  if (typeof apilink != "undefined" && apilink.length > 0) {
    link = apilink;
  }
  link = link +
    `thu-chi-ngoai-le/in-danh-sach-thu-chi-ngoai-le-data?tungay=${dataSearch.tungay}&denngay=${dataSearch.denngay}&ten=${dataSearch.ten}&nhanvien=${dataSearch.nhanvien}&loaiphieu=${dataSearch.loaiphieu}`;
  return (
    <>
      <PrintDataContent link={link} loai={"ThuNgoaiLePrint"} />
    </>
  );


};
